/**
 * Numeric hierarchy levels for each role.
 * Higher numbers indicate greater privilege.
 */
const HIERARCHY: Record<string, number> = {
  Admin: 4,
  Organizer: 3,
  Delegate: 2,
  Attendee: 1,
};

/**
 * Returns true when the user's role is at or above the required role
 * in the hierarchy. Unknown roles are treated as level 0 (no access).
 *
 * @param userRole - The role of the current user
 * @param requiredRole - The minimum role required for access
 */
export function isAtLeast(userRole: string, requiredRole: string): boolean {
  return (HIERARCHY[userRole] ?? 0) >= (HIERARCHY[requiredRole] ?? 0);
}
